import { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { Button, CircularProgress, Dialog, DialogTitle, Divider } from "@mui/material";
import {
	addOrEditModelAction,
	attrConditionalDisplayColObj,
	attributGrpColObj,
	attrTableStrColumnsObj,
	autoUpdateColData,
	constraintsAttrColObj,
	constraintsOptions,
	dependencyAttrColObj,
	getColDefaultValue,
	isColumnDefault,
} from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { grey } from "@mui/material/colors";
import { attrColStyle, dependencyAttrColStyle } from "../StudioAttributes";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import MultipleSelectInput from "components/PimDashboard/CommonComponents/MultipleSelectInput/MultipleSelectInput";
import { arrType, booleaStrOptions, datatypes, inputTypes, objType, selectOptionsKeyName } from "data/globalData";
import { studioAttrGrpAttrAssocObj, studioAttrValAssocObj } from "../data";
import axios from "axios";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { StudioDashboardState } from "context/StudioDashboardContext";

const attrsFromAttrGrpObj = (attrGrpData, selectedAttr) => {
	if (attrGrpData && attrGrpData[studioAttrGrpAttrAssocObj]?.length) {
		let arr = attrGrpData[studioAttrGrpAttrAssocObj];
		return arr?.reduce(
			(acc, row) => {
				if (row?.key !== selectedAttr?.key) acc.list.push(row);
				return acc;
			},
			{ type: arrType, list: [] }
		);
	} else return { type: arrType, list: [] };
};

function AddOrEditModal({ action, attrData, setAttrData, attrGrpData, setAttrGrpData, setModalOpen, modalOpen, collection }) {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr, allAttributes } = StudioDashboardState();

	const handleModalClose = () => {
		setModalOpen(false);
		setAttrGrpData();
		setAttrData();
	};
	const [conditionalData, setConditionalData] = useState();
	const initialState = {
		[attrTableStrColumnsObj.name.key]: "",
		[attrTableStrColumnsObj.collection_type.key]: collection.key,
		[attrTableStrColumnsObj.key.key]: "",
		[attrTableStrColumnsObj.input_type.key]: inputTypes.SELECT.key,
		[constraintsAttrColObj.key]: {
			// [constraintsOptions.UNIQUE.key]: false,
			// [constraintsOptions.NOTNULL.key]: false,
			[constraintsOptions.DISPLAY.key]: true,
		},
		[dependencyAttrColObj.key]: new Object(),
		[attrTableStrColumnsObj.data_type.key]: inputTypes.SELECT.key,
		data: {},
		[attrTableStrColumnsObj.sort_no.key]: attrGrpData ? attrGrpData[studioAttrGrpAttrAssocObj]?.length : 0,
		[attributGrpColObj.key]: attrGrpData?.group_id,
	};
	useEffect(() => {
		if (attrData && action === addOrEditModelAction.UPDATE) {
			setAttrInputData(attrData);
			if (attrGrpData?.data?.[attrConditionalDisplayColObj.key]) setConditionalData(attrData?.data);
		} else {
			setAttrInputData({ ...initialState });
			setConditionalData({});
		}
	}, [modalOpen]);
	const [attrInputData, setAttrInputData] = useState({ ...initialState });
	console.log(attrInputData, "attrInputData");

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoadingOpen(true);
		let pendingFields = [];
		Object.keys(attrTableStrColumnsObj)
			?.map((row) => attrTableStrColumnsObj[row])
			.filter((row) => row?.input_type !== inputTypes.AUTO_GENERATE.key)
			.forEach((attr) => {
				let obj = attrInputData;
				if (
					isColumnDefault(attr, obj?.[attr?.key]) &&
					attr?.constraints?.[constraintsOptions.NOTNULL.key] &&
					attr?.input_type !== inputTypes.SELECT.key
				)
					pendingFields.push(attr);
			});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		try {
			let attrArr = attrGrpData[studioAttrGrpAttrAssocObj];
			let body = attrInputData;
			if (attrGrpData?.data?.[attrConditionalDisplayColObj.key]) body = { ...body, data: conditionalData };

			if (action === addOrEditModelAction.UPDATE) {
				const res = await axios.post("/api/studio_attr_master/update_attr", body);

				setAttrGroupsWithAttr({
					...attrGroupsWithAttr,
					[attrGrpData?.group_id]: {
						...attrGrpData,
						[studioAttrGrpAttrAssocObj]: attrArr?.map((row) => {
							if (row.key === attrInputData.key) return { ...body, res };
							else return row;
						}),
					},
				});
			} else {
				if (attrInputData?.data_type === datatypes.BOOLEAN.key)
					body = {
						...body,
						[studioAttrValAssocObj]: [
							{
								value: booleaStrOptions.YES.key,
							},
							{
								value: booleaStrOptions.NO.key,
							},
						],
					};
				const res = await axios.post("/api/studio_attr_master/create_attr", body);
				setAttrGroupsWithAttr({
					...attrGroupsWithAttr,
					[attrGrpData?.group_id]: {
						...attrGrpData,
						[studioAttrGrpAttrAssocObj]: [...attrArr, res.data],
					},
				});
			}
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: action === addOrEditModelAction.UPDATE ? "Attribute Updated" : "Attribute Created",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			handleModalClose();
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	const handleDependencyAdd = (value) => {
		setAttrInputData({
			...attrInputData,
			[dependencyAttrColObj.key]: value?.reduce((acc, row) => {
				acc[row?.key] = true;
				return acc;
			}, {}),
		});
	};
	const handleDependencyDelete = (value) => {
		let obj = attrInputData[dependencyAttrColObj.key];
		delete obj[value];
		setAttrInputData({
			...attrInputData,
			[dependencyAttrColObj.key]: obj,
		});
	};
	const handleConstraintAdd = (value) => {
		setAttrInputData({
			...attrInputData,
			[constraintsAttrColObj.key]: value?.reduce((acc, row) => {
				acc[row?.key] = true;
				return acc;
			}, {}),
		});
	};
	const handleConstraintDelete = (value) => {
		let obj = attrInputData[constraintsAttrColObj.key];
		delete obj[value];
		setAttrInputData({
			...attrInputData,
			[constraintsAttrColObj.key]: obj,
		});
	};
	if (attrInputData && modalOpen)
		return (
			<Dialog onClose={handleModalClose} open={modalOpen} maxWidth="md" fullWidth>
				<Stack component="form" onSubmit={handleSubmit} p={1} spacing={1}>
					<Box>
						<Typography variant="h6" pt={0} width={"100%"} textTransform="capitalize">
							{action === addOrEditModelAction.UPDATE
								? `Update ${attrData && attrData[attrTableStrColumnsObj.name.key]}`
								: "Add Attribute"}
						</Typography>

						{/* <Typography variant="h4" pt={0} width={"100%"}>
								
								</Typography> */}
						<Divider sx={{ width: "100%", mt: 1 }} />
					</Box>
					<Box display="flex" flexWrap="wrap" columnGap="3%" rowGap="15px" p={1}>
						{/* <Typography variant="body1" width="100%">
								Main Details
							</Typography> */}
						{attrInputData &&
							Object.keys(attrTableStrColumnsObj)?.map((columnKey) => {
								const column = attrTableStrColumnsObj[columnKey];
								let options = column?.[selectOptionsKeyName];

								if (
									[inputTypes.SELECT.key, inputTypes.MULTIPLE_SELECT.key]?.includes(
										column[attrTableStrColumnsObj.input_type.key]
									) &&
									options?.type !== objType
								) {
									let list = [];
									console.log(
										column,
										attrInputData,

										"columnsd........."
									);
									let dependentCols = Object.keys(attrTableStrColumnsObj)
										?.map((row) => attrTableStrColumnsObj[row])
										?.filter((row) => column?.dependency?.[row.key] === true);
									if (dependentCols?.length) {
										column[selectOptionsKeyName]?.list?.forEach((attrVal) => {
											let push = true;
											dependentCols.forEach((col) => {
												if (
													attrInputData?.[col.key] &&
													(col.key === attrTableStrColumnsObj.input_type.key ||
														attrInputData?.[col.key] !== getColDefaultValue(col))
												)
													if (attrVal?.dependency?.[col.key]?.includes(attrInputData?.[col.key])) {
													} else push = false;
											});
											if (push) list.push(attrVal);
										});
									} else list = column[selectOptionsKeyName];
									if (column.key === "category") console.log(column, dependentCols, list, "dependentCols.........");
									options = {
										type: arrType,
										list,
									};
								}
								return (
									<RenderInputField
										column={{ ...attrTableStrColumnsObj[columnKey], [selectOptionsKeyName]: options }}
										data={attrInputData}
										setData={setAttrInputData}
										selectOptObjName={selectOptionsKeyName}
										dependencyColData={action === addOrEditModelAction.CREATE ? autoUpdateColData : {}}
									/>
								);
							})}
						{/* attr Group */}
						<RenderInputField
							column={{
								...attributGrpColObj,
								[selectOptionsKeyName]: {
									type: arrType,
									list: Object.keys(attrGroupsWithAttr)?.map((row) => {
										let attrGrp = attrGroupsWithAttr[row];
										return { key: attrGrp?.group_id, name: attrGrp?.name };
									}),
								},
								getOptionLabel: (option) => option?.key?.toUpperCase(),
							}}
							data={attrInputData}
							setData={setAttrInputData}
							selectOptObjName={selectOptionsKeyName}
							// dependencyColData={autoUpdateColData}
						/>
						{/* dependency */}
						<Stack spacing={1} width="40%">
							<Typography variant="subtitle2" color={grey[600]}>
								{dependencyAttrColObj.name}
							</Typography>
							{attrGrpData && (
								<MultipleSelectInput
									disabled={attrData && action === addOrEditModelAction.UPDATE}
									placeHolder={dependencyAttrColObj.name}
									chips={
										attrInputData[dependencyAttrColObj.key]
											? Object.keys(attrInputData[dependencyAttrColObj.key]).reduce((acc, row) => {
													if (attrInputData[dependencyAttrColObj.key][row])
														acc.push({ name: row?.toUpperCase(), key: row });
													return acc;
											  }, [])
											: []
									}
									options={{
										type: arrType,
										list: allAttributes?.filter(
											(row) => row[attrTableStrColumnsObj.key.key] !== attrData?.[attrTableStrColumnsObj.key.key]
										),
									}}
									handleListAdd={handleDependencyAdd}
									onDelete={handleDependencyDelete}
								/>
							)}
						</Stack>
						{/* constraint Options */}
						<Stack spacing={1} width="45%">
							<Typography variant="subtitle2" color={grey[600]}>
								{constraintsAttrColObj.name}
							</Typography>
							{attrGrpData && (
								<MultipleSelectInput
									disabled={attrData && action === addOrEditModelAction.UPDATE}
									placeHolder={constraintsAttrColObj.name}
									chips={
										attrInputData[constraintsAttrColObj.key]
											? Object.keys(attrInputData[constraintsAttrColObj.key])?.reduce((acc, row) => {
													console.log(row, "rowrowrowrow");
													if (attrInputData[constraintsAttrColObj.key][row])
														acc.push({ name: row?.toUpperCase(), key: row });
													return acc;
											  }, [])
											: []
									}
									options={constraintsAttrColObj.option_data}
									handleListAdd={handleConstraintAdd}
									onDelete={handleConstraintDelete}
								/>
							)}
						</Stack>

						{/* conditional Attr */}
						{attrGrpData?.data?.[attrConditionalDisplayColObj.key] && (
							<RenderInputField
								// width="40%"
								longWidth="80%"
								key={allAttributes}
								column={{
									...attrConditionalDisplayColObj,
									[selectOptionsKeyName]: {
										type: arrType,
										list: allAttributes.filter(
											(row) =>
												row[attrTableStrColumnsObj.key.key] ===
												attrGrpData?.data?.[attrConditionalDisplayColObj.key]
										)[0][selectOptionsKeyName],
										getOptionLabel: (option) => {
											return { name: option.value, key: option.value };
										},
									},
								}}
								data={conditionalData}
								setData={setConditionalData}
								selectOptObjName={selectOptionsKeyName}
								multiple={true}
								// dependencyColData={}
							/>
						)}
					</Box>
					<Box
						display="flex"
						flexWrap="wrap"
						pt={4}
						rowGap={3}
						className="vendorInputForm"
						columnGap={6}
						zIndex={-1}
						justifyContent="center"></Box>

					<Box alignSelf="flex-end" display="flex" columnGap={"10px"}>
						<Button variant="outlined" size="small" onClick={handleModalClose}>
							Cancel
						</Button>
						<Button variant="contained" type="submit" size="small">
							{action === "UPDATE" ? "UPDATE" : "CREATE"}
						</Button>
					</Box>
				</Stack>
			</Dialog>
		);
	else return <></>;
}

export default AddOrEditModal;
